


























































































































































import "./review-setup.less";
import Vue from "vue";
import iForm from "iView";
import moment from "moment-timezone";
import { Model } from "vue-property-decorator";
import { mapState, mapGetters } from "vuex";
import RoleSelector from "./defined-role-selector.vue";
import GradeSelector from "./defined-grade-selector.vue";
import DefinedColorPicker from "./../common/defined-color-picker.vue";
import VueTagsInput from "@johmun/vue-tags-input";

let _ = require("lodash");

export default Vue.extend({
  name: "review-copy",
  components: {
    "defined-role-selector": RoleSelector,
    "defined-grade-selector": GradeSelector,
    DefinedColorPicker,
    VueTagsInput,
  },
  props: {
    review: Object,
    showEditor: Boolean,
  },
  data() {
    return {
      rules: {
        name: [
          {
            required: true,
            message: "Please fill in the Review Name",
            trigger: "blur",
          },
          {
            type: "string",
            max: 40,
            message: "Please limit your Review Name to max 40 characters. Thanks!",
            trigger: "blur",
          },
        ],
        description: [
          {
            type: "string",
            max: 1200,
            message: "Please limit your Review Description to max 1,200 characters. Thanks!",
            trigger: "blur",
          },
        ],
        hashTagList: [
          {
            type: "array",
            required: true,
            message: "Please fill in the Grouping Tags",
          },
        ],
        parentRoleName: [
          {
            required: true,
            message: "Please fill in the parent role name",
            trigger: "change",
          },
          {
            type: "string",
            max: 20,
            message: "Please limit parent role name to max 20 characters. Thanks!",
            trigger: "change",
          },
        ],
        childRoleName: [
          {
            required: true,
            message: "Please fill in the child role name",
            trigger: "change",
          },
          {
            type: "string",
            max: 20,
            message: "Please limit child role name to max 20 characters. Thanks!",
            trigger: "change",
          },
        ],
        editRole: [
          {
            required: true,
            type: "number",
            message: "Please select a role",
            trigger: "blur",
          },
        ],
        gradingOption: [
          {
            required: true,
            type: "number",
            message: "Please select a grading model",
            trigger: "blur",
          },
        ],
        grades: [
          {
            required: true,
            message: "Please define the status scales",
          },
        ],
        timeline: [
          {
            required: true,
            message: "Please input the Review Timeline",
          },
          {
            validator(rule, value, callback, source, options) {
              let errors = [];
              if (value[0] === "") {
                errors.push("Please input the Review Timeline");
              }

              callback(errors);
            },
          },
        ],
      },
      gradeRules: {
        name: [
          {
            required: true,
            message: "*",
            trigger: "change",
          },
          {
            type: "string",
            max: 20,
            message: "Max 20 characters.",
            trigger: "change",
          },
        ],
        from: [
          {
            type: "number",
            required: true,
            message: "*",
            trigger: "change",
          },
        ],
      },
      activePage: "",
      tag: "",
      tags: [],
      currentReview: {
        name: null,
        description: "",
        hashTags: "",
        hashTagList: [],
        editRole: NaN,
        gradingOption: NaN,
        parentRoleName: null,
        childRoleName: null,
        gradeModel: null,
        timezoneOffset: NaN,
        timezoneName: null,
        timeline: [],
        grades: [],
        members: [],
      },
    };
  },
  watch: {
    showModal(newVal) {
      this.gotoPage("details");

      if (newVal === true) {
        this.currentReview.name = this.review.name;
        this.currentReview.description = this.review.description;
        this.currentReview.hashTags = this.review.hashTags;
        this.currentReview.hashTagList = this.currentReview.hashTags ? JSON.parse(this.currentReview.hashTags) : [];
        this.currentReview.editRole = this.review.editRole;
        this.currentReview.gradingOption = this.review.gradingOption;
        this.currentReview.parentRoleName = this.review.parentRoleName;
        this.currentReview.childRoleName = this.review.childRoleName;
        this.currentReview.timezoneOffset = new Date().getTimezoneOffset();
        this.currentReview.timezoneName = moment.tz.guess();
        this.currentReview.timeline = this.review.timeline;
        this.currentReview.members = this.review.members;
        this.currentReview.gradeModel = this.review.gradeModel;
        this.currentReview.grades = this.currentReview.gradeModel ? JSON.parse(this.currentReview.gradeModel) : [];
      }
    },
  },
  computed: {
    ...mapGetters("review", ["editRoleOptions", "gradingOptions"]),
    showModal(): any {
      return this.showEditor;
    },
    getDurationString(): any {
      let timeline = this.currentReview.timeline;
      if (timeline != null && timeline.length == 2) {
        let end = moment(timeline[1]);
        let start = moment(timeline[0]);

        let duration = end.diff(start, "days");
        return `${duration} Day(s)`;
      } else {
        return "";
      }
    },
    detailsCompleted(): any {
      let review = this.currentReview;
      return review.name != null && review.hashTagList.length > 0 && review.timeline.length === 2;
    },
    rolesCompleted(): any {
      let review = this.currentReview;
      return review.editRole >= 0 && review.gradingOption >= 0 && review.parentRoleName !== null && review.parentRoleName !== "" && review.childRoleName !== null && review.childRoleName !== "";
    },
    measurementCompleted(): any {
      return this.currentReview.grades.length > 0;
    },
  },
  methods: {
    handleSelectRoleNames(item) {
      let names = item.label.split(" / ");
      this.currentReview.parentRoleName = names[0];
      this.currentReview.childRoleName = names[1];
    },
    handleSelectDefinedGrade(item) {
      this.currentReview.grades = item.grades.map((grade) => {
        return Object.assign({}, grade);
      });
    },
    handleRemoveGrade(grade) {
      for (var i = 0; i < this.currentReview.grades.length; i++) {
        if (this.currentReview.grades[i] === grade) {
          this.currentReview.grades.splice(i, 1);
        }
      }
    },
    handleAddGrade() {
      this.currentReview.grades.push({ name: "", color: "#ED4014", from: null });
    },
    getToValue(grades, index) {
      let to = NaN;
      if (index - 1 >= 0) {
        to = grades[index - 1].from === null || isNaN(grades[index - 1].from) ? NaN : grades[index - 1].from - 1;
      } else {
        to = 100;
      }

      return isNaN(to) ? " " : `% to ${to} %`;
    },
    handleHidden(visible) {
      if (!visible) {
        try {
          (this.$refs.ReviewForm as any).resetFields();
        } catch (error) {}
      }
    },
    handleSave() {
      event.preventDefault();
      let target = (event.target as any).closest("button") as HTMLButtonElement;
      target.disabled = true;
      let form = this.$refs.ReviewForm;

      (this.$refs.SetupForm as any).validate((valid: boolean) => {
        if (valid) {
          let timeline = this.currentReview.timeline;

          let reviewDto = {
            id: this.review.id,
            name: this.currentReview.name,
            description: this.currentReview.description,
            hashTags: JSON.stringify(this.currentReview.hashTagList),
            editRole: this.currentReview.editRole,
            gradingOption: this.currentReview.gradingOption,
            parentRoleName: this.currentReview.parentRoleName,
            childRoleName: this.currentReview.childRoleName,
            gradeModel: JSON.stringify(this.currentReview.grades),
            timezoneOffset: this.currentReview.timezoneOffset,
            timezoneName: this.currentReview.timezoneName,
            startDate: timeline && timeline.length === 2 ? timeline[0].toLocaleDateString() : "",
            endDate: timeline && timeline.length === 2 ? timeline[1].toLocaleDateString() : "",
            members: this.currentReview.members,
          };

          let actionName = "review/copy";
          let context = this;
          context.$store.dispatch(actionName, { data: reviewDto }).then((response) => {
            context.$emit("cancel");
            target.disabled = false;
          });
        } else {
          target.disabled = false;
        }
      });
    },
    handlerWizardStep(forward) {
      let steps = ["details", "measurement"];
      let nextStepIndex = _.findIndex(steps, (step) => step === this.activePage) + (forward ? 1 : -1);
      this.gotoPage(steps[nextStepIndex]);
    },
    gotoPage(name) {
      this.activePage = name;
    },
  },
});
